<div class="chart-wrapper">
  <canvas baseChart 
      [datasets]="lineChartData" 
      [labels]="lineChartLabels" 
      [options]="lineChartOptions"
      [legend]="lineChartLegend" 
      [chartType]="lineChartType">
      
  </canvas>
</div>